<script context="module">
	/** static properties so we can have unique ids for each Input */
	export let _id = 1;
</script>

<script lang="ts">
	import Fieldset from './Fieldset.svelte';

	const generatedId = `vv-input-${_id++}`;
	let _class = '';
	export { _class as class };
	export let fieldsetClass = '';
	export let labelClass = '';

	export let errors: string[] = [];
	export let id = '';
	export let value = '';
	export let onBeforeInput = (value: string, e: Event) => {};
</script>

<Fieldset {fieldsetClass} {labelClass} for={id || generatedId}>
	<slot name="label" slot="label" />
	<input
		id={id || generatedId}
		class="rounded px-2 py-1 w-full
        border-solid border-2 border-gray-300
        outline-gray-600
        {$$slots.error || errors.length ? 'border-vv-red-fire' : ''}
        {_class}
        "
		on:input={(e) => onBeforeInput(value, e)}
		bind:value
		on:input
		on:change
		on:keyup
		on:focus
		on:blur
		type="text"
		{...$$restProps}
	/>
	<slot name="error" />

	{#if errors.length}
		<ul class="text-vv-red-fire">
			{#each errors as error}
				<li>{error}</li>
			{/each}
		</ul>
	{/if}
</Fieldset>
